import { GraphQLError } from "graphql";

export class GraphQLErrorService {
    public static permissionDenied = "PERMISSION_DENIED";

    public static log(errors: readonly GraphQLError[]) {
        errors.forEach(({ message, locations, path }) =>
            console.error(
                `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`,
            ),
        );
    }

    public static isPermissionDenied(errors: readonly GraphQLError[]) {
        return errors.some(({ message }) => message.includes(GraphQLErrorService.permissionDenied));
    }
}
